import Events from './Events'

export default class BurgerButton {
    static BURGER_BUTTON_OPEN_CLASS = 'burger-button--open'
    static BURGER_BUTTON_SELECTOR = '.js-burger-button'

    constructor() {
        this.burgerButton = document.querySelector(BurgerButton.BURGER_BUTTON_SELECTOR)
        this.initEventListener()
    }

    initEventListener() {
        document.addEventListener(Events.CLICK_ON_BACKGROUND_LAYER_EVENT, () => {
            this.close()
        })
        this.burgerButton.addEventListener('click', () => {
            if (this.burgerButton.classList.contains(BurgerButton.BURGER_BUTTON_OPEN_CLASS)) {
                this.close()
                document.dispatchEvent(new Event(Events.CLOSE_NAVBAR_EVENT))
            } else {
                this.open()
                document.dispatchEvent(new Event(Events.OPEN_NAVBAR_EVENT))
            }
        })
    }

    open() {
        this.burgerButton.classList.add(BurgerButton.BURGER_BUTTON_OPEN_CLASS)
    }

    close() {
        this.burgerButton.classList.remove(BurgerButton.BURGER_BUTTON_OPEN_CLASS)
    }
}
